import { render, staticRenderFns } from "./IndexListImg.vue?vue&type=template&id=45123380&scoped=true&"
import script from "./IndexListImg.vue?vue&type=script&lang=js&"
export * from "./IndexListImg.vue?vue&type=script&lang=js&"
import style0 from "./IndexListImg.vue?vue&type=style&index=0&id=45123380&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45123380",
  null
  
)

export default component.exports